<template>
	<section class="no-marginbottom">
		<h2>Beschwerden ({{ complaints ? complaints.length : 0 }})</h2>
	</section>
	<swiper
		v-if="isMobile"
		:direction="'horizontal'"
		:loop="false"
		:spaceBetween="20"
		:slides-per-view="complaints && complaints.length > 1 ? 1.25 : 1"
		:centeredSlides="false"
		:freeMode="{ enabled: false, sticky: false }"
		:mousewheel="true"
		:class="'slider--boxes'"
	>
		<swiper-slide v-for="item in complaints" :key="item.hid">
			<BoxComplaint :complaint="item" />
		</swiper-slide>
	</swiper>
	<section v-else>
		<ComplaintsTable
			:tableData="complaints ? complaints : []"
			:totalCount="complaints ? complaints.length : 0"
			@loadNextPage="$emit('loadNextPage')"
			:shouldSeePersonalData="false"
		/>
	</section>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue';
import { useStore } from '@/store';
import { ComplaintResponse } from '../../types/types';
import BoxComplaint from '@/components/boxes/BoxComplaint.vue';
import ComplaintsTable from '@/components/tables/ComplaintsTable.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default defineComponent({
	name: 'SectionBeschwerden',
	data() {
		return {};
	},
	props: {
		complaints: {
			type: Array as PropType<ComplaintResponse[]>,
		},
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			store,
			isMobile,
		};
	},
	emits: ['loadNextPage'],
	components: {
		BoxComplaint,
		ComplaintsTable,
		Swiper,
		SwiperSlide,
	},
});
</script>
